// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_sliders.styl
// module id = 183
// module chunks = 0